// import React from "react";
// import "./index.css";
// import App from "./App";
// import * as ReactDOM from "react-dom/client";
// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(

// <React.StrictMode>
//     <App />
// </React.StrictMode>
// );

import React from "react";
import "./index.css";
import App from "./App";
import * as ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// ✅ Register service worker for notifications with actions
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.register('sw.js')
    .then(reg => {
      // console.log("✅ Service Worker registered:", reg);
    })
    .catch(err => {
      console.error("❌ Service Worker registration failed:", err);
    });
}
